export enum CARD_TYPE {
  CASES = 'cases',
  BROKER_PORTAL = 'portal',
}
